"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseQuestionLabel = exports.checkInput = void 0;
const __1 = require("..");
const react_phone_number_input_1 = require("react-phone-number-input");
const utils_1 = require("./utils");
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const urlRegex = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
const checkInput = (inputValue, type, isRequired) => {
    if (!isRequired)
        return true;
    let inputIsValid = false;
    switch (type) {
        case __1.InputType.EMAIL:
            inputIsValid = emailRegex.test(inputValue);
            break;
        case __1.InputType.PHONE:
            inputIsValid = (0, react_phone_number_input_1.isPossiblePhoneNumber)(inputValue);
            break;
        case __1.InputType.WEBSITE:
            inputIsValid = urlRegex.test(inputValue);
            break;
    }
    return inputIsValid;
};
exports.checkInput = checkInput;
const parseQuestionLabel = (step, stepIndex, questionVariables) => {
    const variable = questionVariables.find((variable) => variable.stepId === step.id);
    if (variable) {
        return variable.name;
    }
    const questionLabel = [...step.questionMessages]
        .reverse()
        .map((message) => {
        const { value } = message;
        if (!(0, utils_1.isDefined)(value))
            return "";
        if (typeof value === "string") {
            return value;
        }
        if ("plainText" in value) {
            return value.plainText;
        }
    })
        .filter((message) => message)
        .shift();
    return !questionLabel ? `question ${stepIndex + 1}` : questionLabel.trim();
};
exports.parseQuestionLabel = parseQuestionLabel;
//# sourceMappingURL=inputs.js.map